import { render } from "./ShopApiAccess.vue?vue&type=template&id=3d4fad75&scoped=true"
import script from "./ShopApiAccess.vue?vue&type=script&lang=ts"
export * from "./ShopApiAccess.vue?vue&type=script&lang=ts"

import "./ShopApiAccess.vue?vue&type=style&index=0&id=3d4fad75&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3d4fad75"

export default script